import Message from "./Message";

export function pageView() {
    const analytics = window.maglrAnalyticsSettings ?? window.maglrSettings?.analytics
    if (window.gtag && analytics) {
        let data = {
            page_title: document.title,
            page_location: window.location.href,
            page_path: window.location.pathname,
        }
        if( analytics.ga_group === 'GA3'){
            data.send_to = 'GA3';
            gtag('event', 'page_view', addCustomDimensionData(data))
        }
        if( analytics.ga_group === 'GA4') {
            data.send_to = 'GA4';
            gtag('event', 'page_view', addDefaultDataGA4(data))
        }
    }
    pushGTMEvent({
        'hitType': 'page_view',
        'page': window.location.pathname,
    })
}

export function pushAnalyticsEvent(data = {}){
    const analytics = window.maglrAnalyticsSettings ?? window.maglrSettings?.analytics
    window.maglrController.bounceRateTimer && clearTimeout(window.maglrController.bounceRateTimer); // clear the bouceRateTimer if it still exists
    if (window.gtag && analytics) {

        if( data.dataGA3 && analytics.ga_group === 'GA3'){
            gtag('event', data.dataGA3.action, addCustomDimensionData({
                'event_category': data.dataGA3.type,
                'event_label': data.dataGA3.label,
                'value': data.dataGA3.value,
                'send_to': 'GA3'
            }));
        }
        if( data.dataGA4 && analytics.ga_group === 'GA4'){
            data.dataGA4.data.send_to = 'GA4';
            gtag('event', data.dataGA4.type, addDefaultDataGA4(data.dataGA4.data))
        }

    }

    pushGTMEvent( {
            'hitType': 'event',//
            'page': window.location.pathname,
            'eventCategory': data.type,//example VIDEO, URL_CHANGED
            'eventAction': data.action,//example START, STOP, OPENED
            'eventLabel': data.label,
            'eventValue': data.value,//example https://youtu.be/w?-
        }
    )
}

const addCustomDimensionData = function(data){
    let mutatedCopy = JSON.parse(JSON.stringify(data));
    //Set custom dimension data for current event
    mutatedCopy.dimension1 = `${window.maglrController.currentSpread.settings._client_globals.client_id || window._maglrClientId || window.client_id}`; // cliend_id (window._maglrClientId = singelagemode fallback, window.client_id = frontend fallback)
    mutatedCopy.dimension2 = `${window.maglrController.currentSpread.settings._spread_globals.issue_id}`; // issue_id
    mutatedCopy.dimension3 = `${window.maglrController.currentSpread.settings._spread_globals.spread_id}`; // spread_id
    if(window.maglrController._singleSpreadMode){
        mutatedCopy.dimension4 = window.maglrController._singleSpreadMode; // pageType (singlepage, embed, publication, proposal, personalised, offline, zip)
    }
    if(window.maglrEmbedId){
        mutatedCopy.dimension5 = window.maglrEmbedId; // pageHash (code embed, of code bij personalisatiemagazine)
    }
    if(window.maglrController.currentSpread.settings._spread_globals.user_id){
        mutatedCopy.dimension6 = `${window.maglrController.currentSpread.settings._spread_globals.user_id}`; // user_id of user that created the current issue
    }

    return mutatedCopy;
}

const addDefaultDataGA4 = function(data) {
    let mutatedCopy = JSON.parse(JSON.stringify(data));

    mutatedCopy.language = navigator.language || navigator.userLanguage
    mutatedCopy.page_location = window.location.pathname
    mutatedCopy.page_referrer = document.referrer
    mutatedCopy.page_title = window.maglrController.currentSpread.settings._spread_globals.spread_title
    mutatedCopy.screen_resolution = window.screen.width+'x'+window.screen.height

    mutatedCopy.client_id = window.maglrController.currentSpread.settings._client_globals.client_id || window._maglrClientId || window.client_id; // cliend_id (window._maglrClientId = singelagemode fallback, window.client_id = frontend fallback)
    mutatedCopy.issue_id = window.maglrController.currentSpread.settings._spread_globals.issue_id; // issue_id
    mutatedCopy.spread_id = window.maglrController.currentSpread.settings._spread_globals.spread_id; // spread_id
    if(window.maglrController._singleSpreadMode){
        mutatedCopy.issue_type = window.maglrController._singleSpreadMode; // pageType (singlepage, embed, publication, proposal, personalised, offline, zip)
    }
    if(window.maglrEmbedId){
        mutatedCopy.issue_hash = window.maglrEmbedId; // pageHash (code embed, of code bij personalisatiemagazine)
    }
    // mutatedCopy.maglr_user_id

    return mutatedCopy
}

/**
 * Send Event updates like clicks, starts video's etc
 *
 * @param {Object} data
 * @private
 */
export function pushGTMEvent(data) {
    try {
        const gtmData = createGTMEventData(data);
        window.dataLayer && window.dataLayer.push(gtmData);

        window.maglrController.currentSpread && window.maglrController.currentSpread.embedded && Message.sendEmbedMessage( "PUSH_GTM", gtmData);
    } catch (e) {
        console.warn('GTM Error: ', e);
    }
}

const createGTMEventData = function (data) {
    let gtmData = {
        event : data.hitType, // pageview | maglrUserEvent | maglrPageEvent(statusupdate)
    };

    if(data.hitType === 'event'){
        gtmData.event = 'maglrUserEvent';
        if(data.eventCategory){
            gtmData.maglrCategory = data.eventCategory;
        }
        if(data.eventAction){
            gtmData.maglrAction = data.eventAction;
        }
        if(data.eventLabel){
            gtmData.maglrLabel = data.eventLabel.replace(/ :: \([0-9]*\|[0-9]*\)/, '');
        }
        if(data.eventValue){
            gtmData.maglrValue = data.eventValue;
        }
    }

    //Add the Additional data when we have it

    if(window.maglrController.currentSpread){
        const globals = window.maglrController.currentSpread.settings._spread_globals;
        gtmData['maglrIssueID'] = globals.issue_id;
        gtmData['maglrSpreadID'] = globals.spread_id;
        gtmData['maglrPageStatus'] = {200:'created', 250: 'stopped', 275: 'paused', 300: 'started'}[window.maglrController.currentSpread.status] || 'spread';
        gtmData['maglrPagePath'] = window.location.pathname; // spread pathname
        gtmData['maglrPageURL'] = window.location.href; // full page url
        gtmData['maglrPageTitle'] = globals.spread_title; // spread title
        gtmData['maglrProjectTitle'] = globals.issue_title; // issue title

        if(window.maglrController._singleSpreadMode){
            gtmData['maglrPageType'] = window.maglrController._singleSpreadMode; // pageType (singlepage, embed, publication, proposal, personalised, offline, zip)
        }
    }

    console.warn("GTM:", data, gtmData);
    return gtmData;
}
